import { Provider } from '@angular/core';
import {
  CreateAlertAndNotificationUseCase,
  CreateEmailNotificationUseCase,
  DeleteAlertAndNotificationUseCase,
  DeleteEmailNotificationUseCase,
  DeleteTaskFormAlertAndNotificationUseCase,
  EditAlertAndNotificationUseCase,
  EditStandardNotificationUseCase,
  GetAlertAndNotificationDetailsUseCase,
  GetChatNotificationDetailsUseCase,
  GetEmailNotificationDetailsUseCase,
  GetListAlertsAndNotificationsUseCase,
  GetListAssetExpressionUseCase,
  GetListCorrespondingAssetsUseCase,
  GetListCorrespondingTasksUseCase,
  GetListEmailNotificationUseCase,
  GetStandardNotificationUseCase,
  GetTaskTemplateExpressionUseCase,
} from '@app/application';
import { CreateChatNotificationUseCase } from '@app/application/use-cases/alerts-and-notifications/create-chat-notification.use-case';
import { DeleteChatNotificationUseCase } from '@app/application/use-cases/alerts-and-notifications/delete-chat-notification.use-case';
import { GetListChatNotificationUseCase } from '@app/application/use-cases/alerts-and-notifications/get-list-chat-notification.use-case';
import { GetListNonVesselSectorUseCase } from '@app/application/use-cases/alerts-and-notifications/get-list-non-vessel-sector.use-case';
import { AlertsAndNotificationsRepository } from '@app/domain';
import { AlertsAndNotificationsRepositoryImpl } from '../repositories/alerts-and-notifications.repository.impl';

// The dependency injection wiring
export const ALERTS_AND_NOTIFICATIONS_PROVIDERS: Provider[] = [
  // Repositories
  {
    provide: AlertsAndNotificationsRepository,
    useClass: AlertsAndNotificationsRepositoryImpl,
  },
  // Get List Alerts And Notifications Tasks Use Case
  {
    provide: GetListAlertsAndNotificationsUseCase,
    // The factory function receives the dependencies listed in `deps` as arguments
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) => new GetListAlertsAndNotificationsUseCase(alertsAndNotificationsRepo), // The factory function returns the instance of the class
    // List the tokens for the dependencies Angular needs to inject into the factory
    deps: [AlertsAndNotificationsRepository],
  },
  // Get Alert And Notification Details Use Case
  {
    provide: GetAlertAndNotificationDetailsUseCase,
    // The factory function receives the dependencies listed in `deps` as arguments
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) => new GetAlertAndNotificationDetailsUseCase(alertsAndNotificationsRepo), // The factory function returns the instance of the class
    // List the tokens for the dependencies Angular needs to inject into the factory
    deps: [AlertsAndNotificationsRepository],
  },
  // Create Alert And Notification Use Case
  {
    provide: CreateAlertAndNotificationUseCase,
    // The factory function receives the dependencies listed in `deps` as arguments
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) => new CreateAlertAndNotificationUseCase(alertsAndNotificationsRepo), // The factory function returns the instance of the class
    // List the tokens for the dependencies Angular needs to inject into the factory
    deps: [AlertsAndNotificationsRepository],
  },
  // Edit Alert And Notification Use Case
  {
    provide: EditAlertAndNotificationUseCase,
    // The factory function receives the dependencies listed in `deps` as arguments
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) => new EditAlertAndNotificationUseCase(alertsAndNotificationsRepo), // The factory function returns the instance of the class
    // List the tokens for the dependencies Angular needs to inject into the factory
    deps: [AlertsAndNotificationsRepository],
  },
  // Delete Alert And Notification Use Case
  {
    provide: DeleteAlertAndNotificationUseCase,
    // The factory function receives the dependencies listed in `deps` as arguments
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) => new DeleteAlertAndNotificationUseCase(alertsAndNotificationsRepo), // The factory function returns the instance of the class
    // List the tokens for the dependencies Angular needs to inject into the factory
    deps: [AlertsAndNotificationsRepository],
  },
  // Delete Task From Alert And Notification Use Case
  {
    provide: DeleteTaskFormAlertAndNotificationUseCase,
    // The factory function receives the dependencies listed in `deps` as arguments
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) =>
      new DeleteTaskFormAlertAndNotificationUseCase(alertsAndNotificationsRepo), // The factory function returns the instance of the class
    // List the tokens for the dependencies Angular needs to inject into the factory
    deps: [AlertsAndNotificationsRepository],
  },
  // Get List Corressponding Tasks Use Case
  {
    provide: GetListCorrespondingTasksUseCase,
    // The factory function receives the dependencies listed in `deps` as arguments
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) => new GetListCorrespondingTasksUseCase(alertsAndNotificationsRepo), // The factory function returns the instance of the class
    // List the tokens for the dependencies Angular needs to inject into the factory
    deps: [AlertsAndNotificationsRepository],
  },
  // Get List Asset Expression Use Case
  {
    provide: GetListAssetExpressionUseCase,
    // The factory function receives the dependencies listed in `deps` as arguments
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) => new GetListAssetExpressionUseCase(alertsAndNotificationsRepo), // The factory function returns the instance of the class
    // List the tokens for the dependencies Angular needs to inject into the factory
    deps: [AlertsAndNotificationsRepository],
  },
  // Get List Asset Expression Use Case
  {
    provide: CreateEmailNotificationUseCase,
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) => new CreateEmailNotificationUseCase(alertsAndNotificationsRepo),
    deps: [AlertsAndNotificationsRepository],
  },
  // Get List Email Notification Use Case
  {
    provide: GetListEmailNotificationUseCase,
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) => new GetListEmailNotificationUseCase(alertsAndNotificationsRepo),
    deps: [AlertsAndNotificationsRepository],
  },
  // Get Corresponding Assets Use Case
  {
    provide: GetListCorrespondingAssetsUseCase,
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) => new GetListCorrespondingAssetsUseCase(alertsAndNotificationsRepo),
    deps: [AlertsAndNotificationsRepository],
  },
  // Delete Email Notification Use Case
  {
    provide: DeleteEmailNotificationUseCase,
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) => new DeleteEmailNotificationUseCase(alertsAndNotificationsRepo),
    deps: [AlertsAndNotificationsRepository],
  },
  // Get Email Notification Details Use Case
  {
    provide: GetEmailNotificationDetailsUseCase,
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) => new GetEmailNotificationDetailsUseCase(alertsAndNotificationsRepo),
    deps: [AlertsAndNotificationsRepository],
  },
  // Get Expression For Task Template
  {
    provide: GetTaskTemplateExpressionUseCase,
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) => new GetTaskTemplateExpressionUseCase(alertsAndNotificationsRepo),
    deps: [AlertsAndNotificationsRepository],
  },
  // Get List Standard Notification Use Case
  {
    provide: GetStandardNotificationUseCase,
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) => new GetStandardNotificationUseCase(alertsAndNotificationsRepo),
    deps: [AlertsAndNotificationsRepository],
  },
  // Edit Standard Notification Use Case
  {
    provide: EditStandardNotificationUseCase,
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) => new EditStandardNotificationUseCase(alertsAndNotificationsRepo),
    deps: [AlertsAndNotificationsRepository],
  },
  // Get Chat Notification Use Case
  {
    provide: GetChatNotificationDetailsUseCase,
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) => new GetChatNotificationDetailsUseCase(alertsAndNotificationsRepo),
    deps: [AlertsAndNotificationsRepository],
  },
  // Create Chat Notification Use Case
  {
    provide: CreateChatNotificationUseCase,
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) => new CreateChatNotificationUseCase(alertsAndNotificationsRepo),
    deps: [AlertsAndNotificationsRepository],
  },
  // Delete Chat Notification Use Case
  {
    provide: DeleteChatNotificationUseCase,
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) => new DeleteChatNotificationUseCase(alertsAndNotificationsRepo),
    deps: [AlertsAndNotificationsRepository],
  },
  // Delete Chat Notification Use Case
  {
    provide: GetListChatNotificationUseCase,
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) => new GetListChatNotificationUseCase(alertsAndNotificationsRepo),
    deps: [AlertsAndNotificationsRepository],
  },
  // Get List Non Vessel Sector Use Case
  {
    provide: GetListNonVesselSectorUseCase,
    useFactory: (
      alertsAndNotificationsRepo: AlertsAndNotificationsRepository
    ) => new GetListNonVesselSectorUseCase(alertsAndNotificationsRepo),
    deps: [AlertsAndNotificationsRepository],
  },
];
